// extracted by mini-css-extract-plugin
export var settingsList = "_2r-0";
export var settingsRow = "_2r-1";
export var warningDot = "_2r-2";